// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container responsiveness */
.DP-main {
    margin-left: 280px;
    margin-top: 10px;
    margin-right: 10px;
}

@media screen and (max-width: 768px) {
    .DP-main {
        margin-left: 20px;
        margin-right: 20px;
    }
}

/* Profile header responsiveness */
.profile-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    position: relative;
}

@media screen and (min-width: 769px) {
    .profile-header {
        flex-direction: row;
        align-items: center;
    }
}

/* Color strip and platform text */
.color-strip {
    height: 50px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.platform-text {
    color: white;
    font-weight: bold;
    font-size: 22px;
}
.platform-icon {
    color: #ffffff;
    margin-right: 5px; /* Gap between icon and text */
    width: 30px !important; 
    height: 30px !important;
  }
/* Back button responsiveness */
.back-button-container {
    margin-bottom: 20px;
}

.back-button {
    background-color: #65CCB7;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

@media screen and (max-width: 768px) {
    .back-button {
        padding: 8px 15px;
    }
}

.back-button svg {
    margin-right: 10px;
}

/* Profile info responsiveness */
.profile-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 10px;
}

@media screen and (min-width: 769px) {
    .profile-info {
      margin-top: 3%;
        flex-direction: row;
        text-align: left;
    }
}

.profile-info img {
    border-radius: 25%;
    margin-bottom: 10px;
    width: 80px;
    height: 80px;
}

@media screen and (min-width: 769px) {
    .profile-info img {
        margin-right: 20px;
        margin-bottom: 0;
        width: 100px;
        height: 100px;
    }
}

.profile-info h1 {
    margin: 0;
    font-size: 24px;
}

.profile-info p {
    margin: 5px 0 10px;
    color: #707070;
}

/* Stats responsiveness */
.stats {
    display: flex;
    gap: 20px;
    margin-top: 10px;
    flex-grow: 1;
    justify-content: space-around;
    width: 100%;
}

@media screen and (min-width: 769px) {
    .stats {
        justify-content: flex-end;
        gap: 50px;
    }
}

.stat {
    display: flex;
    align-items: center;
    gap: 5px;
}

.stat svg {
    font-size: 20px;
    color: #65CCB7;
}

.stat span {
    font-size: 16px;
    color: #707070;
}

.stat strong {
    font-size: 20px;
    color: #000;
}
.faHeart{
    color: #65CCB7;
}
/* Profile navigation responsiveness */
.profile-nav {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

@media screen and (min-width: 769px) {
    .profile-nav {
        flex-direction: row;
    }
}

.tab-button {
    padding: 10px 20px;
    background-color: #f0f0f0;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.tab-button.active {
    background-color: #65CCB7;
    color: white;
}

/* Tab content and section responsiveness */
.tab-content {
    gap: 10px;
    margin-top: inherit;
    /* overflow-y: auto; 
    overflow-x: hidden; 
    height: calc(100vh - 84px);  */

}

/* @media screen and (min-width: 769px) {
    .tab-content {
        grid-template-columns: 1fr 1fr;
    }
} */

/* .section {
    margin-bottom: 20px;

}

 .section.bio,
.section.contact-info,
.section.location,
.section.username-links {
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: white;
}

.section.detail-account-post {
    display: contents; 
    width: 100%;
    padding: 20px;
} */

.detail-post-card {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    min-height: 150px;
    max-width: 100%;
}

.detail-post-info {
    margin-bottom: 10px;
}

.detail-post-info p {
    font-size: 14px;
    color: #333;
}

.detail-post-image img {
    max-width: 100%;
    border-radius: 5px;
}

.detail-post-stats {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #777;
    margin-top: 10px;
}

.detail-post-stats span {
    display: flex;
    align-items: center;
}

.detail-post-stats span svg {
    margin-right: 5px;
} */


/* Tweet responsiveness */
.tweet {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-bottom: 20px;
}

@media screen and (min-width: 769px) {
    .tweet {
        flex-direction: row;
    }
}

.tweet img {
    border-radius: 25%;
    margin-bottom: 20px;
    width: 60px;
    height: 60px;
}

@media screen and (min-width: 769px) {
    .tweet img {
        margin-right: 20px;
        margin-bottom: 0;
    }
}

.tweet-content {
    flex: 1 1;
}

.tweet-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.tweet-author {
    font-weight: bold;
    margin-right: 10px;
}

.tweet-username {
    color: #707070;
}

.tweet-text {
    margin-bottom: 10px;
}

.tweet-stats {
    display: flex;
    align-items: center;
    gap: 20px;
    color: #707070;
}

.tweet-stats i {
    margin-right: 5px;
    color: #65CCB7;
}

.tweet-date {
    margin-left: auto;
    color: #707070;
}
/* About Section Grid */
.about-grid {
    display: grid;
    grid-template-columns: 1fr 1fr; /* Two cards per row */
    gap: 20px;
  }
  
  @media screen and (max-width: 768px) {
    .about-grid {
      grid-template-columns: 1fr; /* One card per row for small screens */
    }
  }
  
  /* Individual Cards */
  /* Updated Card Style */
.section {
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: white;
    margin-bottom: 20px; /* Add space between rows */
    min-height: auto; /* Allow height to adjust dynamically */
  }
  
  /* Heading Styles */
  .section h2 {
    margin-top: 0;
    font-size: 18px;
    color: #333;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
  }
  
  /* Paragraph and Links */
  .section p {
    margin: 10px 0;
    color: #555;
  }
  
  .section a {
    color: #65CCB7;
    text-decoration: none;
  }
  
  .section a:hover {
    text-decoration: underline;
  }
  
  /* Grid Layout for Following */
.following-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
    overflow-y: auto;
    height: 64vh;
  }
  
  /* Individual Following Cards */
  .following-card {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  
  /* Grid Layout for Followers */
.followers-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
    overflow-y: auto;
    height: 64vh;
  }
  
  /* Individual Followers Cards */
  .followers-card {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  /* Card Header Style (Shared Between Followers and Following) */
  .follow-card-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .follow-card-header img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .follow-card-header h3 {
    margin: 0;
    font-size: 16px;
  }
  
  .follow-card-header p {
    margin: 0;
    color: #707070;
  }
  
  /* Location Section */
  .card-location {
    display: flex;
    align-items: center;
    margin: 10px 0;
    color: #707070;
  }
  
  .card-location svg {
    margin-right: 5px;
  }
  
  /* Stats Section */
  .card-stats {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #555;
  }
  
  .card-stats span {
    display: flex;
    align-items: center;
  }
  
  .card-stats svg {
    margin-right: 5px;
    color: #65CCB7;
  }
  
  /* Grid Layout for Posts */
/* Grid Layout for Posts */
.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 20px;
  max-height: 500px; /* Set a height */
  overflow-y: auto; /* Enable vertical scroll */
  padding-right: 10px; 
  }
  
  @media screen and (max-width: 1024px) {
    .posts-grid {
      grid-template-columns: repeat(2, 1fr); /* Two cards per row on medium screens */
    }
  }
  
  @media screen and (max-width: 768px) {
    .posts-grid {
      grid-template-columns: 1fr; /* One card per row on small screens */
    }
  }
  
  /* Individual Post Card */
  .post-card-unique {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  /* Post Header */
  .post-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }
  
  .post-header img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .post-header h3 {
    margin: 0;
    font-size: 16px;
  }
  
  .post-header p {
    margin: 0;
    color: #707070;
  }
  
  /* Post Content */
  .post-content {
    margin-bottom: 10px;
    color: #333;
    font-size: 14px;
  }
  
  /* Post Media Placeholder */
  .post-media {
    margin-bottom: 10px;
  }
  
  .post-media img {
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
    max-height: 200px;
    background-color: #f0f0f0;
  }
  
  /* Post Footer */
  .post-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #555;
  }
  
  /* Post Stats */
  .post-stats {
    display: flex;
    gap: 20px;
  }
  
  .post-stats span {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #707070;
  }
  
  .post-stats svg {
    color: #65CCB7;
  }
  
  /* Post Timestamp */
  .post-timestamp {
    font-size: 12px;
    color: #999;
    text-align: right;
  }
  

  /* Post Link Button */
.post-link {
  display: flex;
  justify-content: flex-end;
  margin-top: -40px;
  margin-left: 54%;
}

.post-link-button {
  background-color: #ffffff;
  color: #65ccb7;
  padding: 6px 6px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}



.post-link-button svg {
  font-size: 14px; /* Icon size */
}

@media screen and (max-width: 768px) {
  .post-link-button {
    padding: 6px 6px;
    font-size: 12px;
  }
}


/* Profile Link Button */
/* .card-link {
  display: flex;
  justify-content: flex-end;
  margin-top: -40px;
  margin-left: 10%;
}  */

.profile-link-button {
  background-color: #ffffff;
  color: #65ccb7;
  padding: 6px 6px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.profile-link-button svg {
  font-size: 14px; /* Icon size */
}

@media screen and (max-width: 768px) {
  .profile-link-button {
    padding: 6px 6px;
    font-size: 12px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/profiling/DetailProfile.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA,kCAAkC;AAClC;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,cAAc;IACd,iBAAiB,EAAE,8BAA8B;IACjD,sBAAsB;IACtB,uBAAuB;EACzB;AACF,+BAA+B;AAC/B;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;MACE,cAAc;QACZ,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,yBAAyB;QACzB,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,2CAA2C;AAC3C;IACI,SAAS;IACT,mBAAmB;IACnB;;kCAE8B;;AAElC;;AAEA;;;;GAIG;;AAEH;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;IACI,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB,EAAE;;;;;IAKE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B,EAAE,sBAAsB;IACtD,SAAS;EACX;;EAEA;IACE;MACE,0BAA0B,EAAE,uCAAuC;IACrE;EACF;;EAEA,qBAAqB;EACrB,uBAAuB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,uBAAuB;IACvB,mBAAmB,EAAE,2BAA2B;IAChD,gBAAgB,EAAE,uCAAuC;EAC3D;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,8BAA8B;AAChC;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA,+BAA+B;EAC/B;IACE,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;;EAGA,8BAA8B;AAChC;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA,+BAA+B;EAC/B;IACE,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,+DAA+D;EAC/D;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA,0BAA0B;AAC5B,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,iBAAiB,EAAE,iBAAiB;EACpC,gBAAgB,EAAE,2BAA2B;EAC7C,mBAAmB;EACnB;;EAEA;IACE;MACE,qCAAqC,EAAE,wCAAwC;IACjF;EACF;;EAEA;IACE;MACE,0BAA0B,EAAE,sCAAsC;IACpE;EACF;;EAEA,yBAAyB;EACzB;IACE,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA,eAAe;EACf;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;;EAGA,qBAAqB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;;;AAIA;EACE,eAAe,EAAE,cAAc;AACjC;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;;AAGA,wBAAwB;AACxB;;;;;IAKI;;AAEJ;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,cAAc;AACjC;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["/* Main container responsiveness */\r\n.DP-main {\r\n    margin-left: 280px;\r\n    margin-top: 10px;\r\n    margin-right: 10px;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    .DP-main {\r\n        margin-left: 20px;\r\n        margin-right: 20px;\r\n    }\r\n}\r\n\r\n/* Profile header responsiveness */\r\n.profile-header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    margin-bottom: 20px;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    position: relative;\r\n}\r\n\r\n@media screen and (min-width: 769px) {\r\n    .profile-header {\r\n        flex-direction: row;\r\n        align-items: center;\r\n    }\r\n}\r\n\r\n/* Color strip and platform text */\r\n.color-strip {\r\n    height: 50px;\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.platform-text {\r\n    color: white;\r\n    font-weight: bold;\r\n    font-size: 22px;\r\n}\r\n.platform-icon {\r\n    color: #ffffff;\r\n    margin-right: 5px; /* Gap between icon and text */\r\n    width: 30px !important; \r\n    height: 30px !important;\r\n  }\r\n/* Back button responsiveness */\r\n.back-button-container {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.back-button {\r\n    background-color: #65CCB7;\r\n    color: white;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    .back-button {\r\n        padding: 8px 15px;\r\n    }\r\n}\r\n\r\n.back-button svg {\r\n    margin-right: 10px;\r\n}\r\n\r\n/* Profile info responsiveness */\r\n.profile-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    margin-top: 10px;\r\n}\r\n\r\n@media screen and (min-width: 769px) {\r\n    .profile-info {\r\n      margin-top: 3%;\r\n        flex-direction: row;\r\n        text-align: left;\r\n    }\r\n}\r\n\r\n.profile-info img {\r\n    border-radius: 25%;\r\n    margin-bottom: 10px;\r\n    width: 80px;\r\n    height: 80px;\r\n}\r\n\r\n@media screen and (min-width: 769px) {\r\n    .profile-info img {\r\n        margin-right: 20px;\r\n        margin-bottom: 0;\r\n        width: 100px;\r\n        height: 100px;\r\n    }\r\n}\r\n\r\n.profile-info h1 {\r\n    margin: 0;\r\n    font-size: 24px;\r\n}\r\n\r\n.profile-info p {\r\n    margin: 5px 0 10px;\r\n    color: #707070;\r\n}\r\n\r\n/* Stats responsiveness */\r\n.stats {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 10px;\r\n    flex-grow: 1;\r\n    justify-content: space-around;\r\n    width: 100%;\r\n}\r\n\r\n@media screen and (min-width: 769px) {\r\n    .stats {\r\n        justify-content: flex-end;\r\n        gap: 50px;\r\n    }\r\n}\r\n\r\n.stat {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n\r\n.stat svg {\r\n    font-size: 20px;\r\n    color: #65CCB7;\r\n}\r\n\r\n.stat span {\r\n    font-size: 16px;\r\n    color: #707070;\r\n}\r\n\r\n.stat strong {\r\n    font-size: 20px;\r\n    color: #000;\r\n}\r\n.faHeart{\r\n    color: #65CCB7;\r\n}\r\n/* Profile navigation responsiveness */\r\n.profile-nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n@media screen and (min-width: 769px) {\r\n    .profile-nav {\r\n        flex-direction: row;\r\n    }\r\n}\r\n\r\n.tab-button {\r\n    padding: 10px 20px;\r\n    background-color: #f0f0f0;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.tab-button.active {\r\n    background-color: #65CCB7;\r\n    color: white;\r\n}\r\n\r\n/* Tab content and section responsiveness */\r\n.tab-content {\r\n    gap: 10px;\r\n    margin-top: inherit;\r\n    /* overflow-y: auto; \r\n    overflow-x: hidden; \r\n    height: calc(100vh - 84px);  */\r\n\r\n}\r\n\r\n/* @media screen and (min-width: 769px) {\r\n    .tab-content {\r\n        grid-template-columns: 1fr 1fr;\r\n    }\r\n} */\r\n\r\n/* .section {\r\n    margin-bottom: 20px;\r\n\r\n}\r\n\r\n .section.bio,\r\n.section.contact-info,\r\n.section.location,\r\n.section.username-links {\r\n    padding: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    background-color: white;\r\n}\r\n\r\n.section.detail-account-post {\r\n    display: contents; \r\n    width: 100%;\r\n    padding: 20px;\r\n} */\r\n\r\n.detail-post-card {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    min-height: 150px;\r\n    max-width: 100%;\r\n}\r\n\r\n.detail-post-info {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.detail-post-info p {\r\n    font-size: 14px;\r\n    color: #333;\r\n}\r\n\r\n.detail-post-image img {\r\n    max-width: 100%;\r\n    border-radius: 5px;\r\n}\r\n\r\n.detail-post-stats {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-size: 14px;\r\n    color: #777;\r\n    margin-top: 10px;\r\n}\r\n\r\n.detail-post-stats span {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.detail-post-stats span svg {\r\n    margin-right: 5px;\r\n} */\r\n\r\n\r\n/* Tweet responsiveness */\r\n.tweet {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n@media screen and (min-width: 769px) {\r\n    .tweet {\r\n        flex-direction: row;\r\n    }\r\n}\r\n\r\n.tweet img {\r\n    border-radius: 25%;\r\n    margin-bottom: 20px;\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n\r\n@media screen and (min-width: 769px) {\r\n    .tweet img {\r\n        margin-right: 20px;\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n.tweet-content {\r\n    flex: 1;\r\n}\r\n\r\n.tweet-header {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.tweet-author {\r\n    font-weight: bold;\r\n    margin-right: 10px;\r\n}\r\n\r\n.tweet-username {\r\n    color: #707070;\r\n}\r\n\r\n.tweet-text {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.tweet-stats {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    color: #707070;\r\n}\r\n\r\n.tweet-stats i {\r\n    margin-right: 5px;\r\n    color: #65CCB7;\r\n}\r\n\r\n.tweet-date {\r\n    margin-left: auto;\r\n    color: #707070;\r\n}\r\n/* About Section Grid */\r\n.about-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr; /* Two cards per row */\r\n    gap: 20px;\r\n  }\r\n  \r\n  @media screen and (max-width: 768px) {\r\n    .about-grid {\r\n      grid-template-columns: 1fr; /* One card per row for small screens */\r\n    }\r\n  }\r\n  \r\n  /* Individual Cards */\r\n  /* Updated Card Style */\r\n.section {\r\n    padding: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    background-color: white;\r\n    margin-bottom: 20px; /* Add space between rows */\r\n    min-height: auto; /* Allow height to adjust dynamically */\r\n  }\r\n  \r\n  /* Heading Styles */\r\n  .section h2 {\r\n    margin-top: 0;\r\n    font-size: 18px;\r\n    color: #333;\r\n    border-bottom: 1px solid #ddd;\r\n    padding-bottom: 5px;\r\n  }\r\n  \r\n  /* Paragraph and Links */\r\n  .section p {\r\n    margin: 10px 0;\r\n    color: #555;\r\n  }\r\n  \r\n  .section a {\r\n    color: #65CCB7;\r\n    text-decoration: none;\r\n  }\r\n  \r\n  .section a:hover {\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  /* Grid Layout for Following */\r\n.following-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n    overflow-y: auto;\r\n    height: 64vh;\r\n  }\r\n  \r\n  /* Individual Following Cards */\r\n  .following-card {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  \r\n  /* Grid Layout for Followers */\r\n.followers-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n    overflow-y: auto;\r\n    height: 64vh;\r\n  }\r\n  \r\n  /* Individual Followers Cards */\r\n  .followers-card {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  /* Card Header Style (Shared Between Followers and Following) */\r\n  .follow-card-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .follow-card-header img {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n  }\r\n  \r\n  .follow-card-header h3 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .follow-card-header p {\r\n    margin: 0;\r\n    color: #707070;\r\n  }\r\n  \r\n  /* Location Section */\r\n  .card-location {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 10px 0;\r\n    color: #707070;\r\n  }\r\n  \r\n  .card-location svg {\r\n    margin-right: 5px;\r\n  }\r\n  \r\n  /* Stats Section */\r\n  .card-stats {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-size: 14px;\r\n    color: #555;\r\n  }\r\n  \r\n  .card-stats span {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .card-stats svg {\r\n    margin-right: 5px;\r\n    color: #65CCB7;\r\n  }\r\n  \r\n  /* Grid Layout for Posts */\r\n/* Grid Layout for Posts */\r\n.posts-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 20px;\r\n  margin-top: 20px;\r\n  max-height: 500px; /* Set a height */\r\n  overflow-y: auto; /* Enable vertical scroll */\r\n  padding-right: 10px; \r\n  }\r\n  \r\n  @media screen and (max-width: 1024px) {\r\n    .posts-grid {\r\n      grid-template-columns: repeat(2, 1fr); /* Two cards per row on medium screens */\r\n    }\r\n  }\r\n  \r\n  @media screen and (max-width: 768px) {\r\n    .posts-grid {\r\n      grid-template-columns: 1fr; /* One card per row on small screens */\r\n    }\r\n  }\r\n  \r\n  /* Individual Post Card */\r\n  .post-card-unique {\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  /* Post Header */\r\n  .post-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .post-header img {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n  }\r\n  \r\n  .post-header h3 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .post-header p {\r\n    margin: 0;\r\n    color: #707070;\r\n  }\r\n  \r\n  /* Post Content */\r\n  .post-content {\r\n    margin-bottom: 10px;\r\n    color: #333;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Post Media Placeholder */\r\n  .post-media {\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .post-media img {\r\n    width: 100%;\r\n    border-radius: 10px;\r\n    object-fit: cover;\r\n    max-height: 200px;\r\n    background-color: #f0f0f0;\r\n  }\r\n  \r\n  /* Post Footer */\r\n  .post-footer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    color: #555;\r\n  }\r\n  \r\n  /* Post Stats */\r\n  .post-stats {\r\n    display: flex;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .post-stats span {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    color: #707070;\r\n  }\r\n  \r\n  .post-stats svg {\r\n    color: #65CCB7;\r\n  }\r\n  \r\n  /* Post Timestamp */\r\n  .post-timestamp {\r\n    font-size: 12px;\r\n    color: #999;\r\n    text-align: right;\r\n  }\r\n  \r\n\r\n  /* Post Link Button */\r\n.post-link {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: -40px;\r\n  margin-left: 54%;\r\n}\r\n\r\n.post-link-button {\r\n  background-color: #ffffff;\r\n  color: #65ccb7;\r\n  padding: 6px 6px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n\r\n.post-link-button svg {\r\n  font-size: 14px; /* Icon size */\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .post-link-button {\r\n    padding: 6px 6px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n\r\n/* Profile Link Button */\r\n/* .card-link {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: -40px;\r\n  margin-left: 10%;\r\n}  */\r\n\r\n.profile-link-button {\r\n  background-color: #ffffff;\r\n  color: #65ccb7;\r\n  padding: 6px 6px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.profile-link-button svg {\r\n  font-size: 14px; /* Icon size */\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .profile-link-button {\r\n    padding: 6px 6px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
